var thumbnailSlider = {
  
  elements: {},

  init: function() {
    this.getElements();
    this.createSlider();
  },

  getElements: function() {
    this.elements.thumbnailContainer = jQuery('.product-media--thumbs');
  },

  createSlider: function() {
    if ( !this.elements.thumbnailContainer.length ) { return false; }

    this.elements.thumbnailContainer.slick({
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 2,
      infinite: true,
      adaptiveHeight: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}

jQuery(document).ready(function(){
  thumbnailSlider.init();
});